module.exports = __webpack_public_path__ + "img/paas_wrapbg2.ab075e84.png";